module.exports = __webpack_public_path__ + "static/media/sleep-basics-large@3x.d59318d8.png";